class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch' || !matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => this.open(), 80);
    });
    this.addEventListener('pointerleave', () => {
      clearTimeout(this.openTimer);
      this.closeTimer = setTimeout(() => {
        if (!this.content.contains(document.activeElement)) this.close();
      }, 180);
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
      this.summary.focus();
    });
  }

  disconnectedCallback() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
  }

  open() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.open = true;
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.summary.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (this.mainDetailsToggle.open) {
      document.querySelectorAll('header-menu').forEach((menu) => { if (menu !== this) menu.close(); });
    }
    this.header.preventHide = !!this.header.querySelector('header-menu details[open]');
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
